module.exports = __webpack_public_path__ + "0811a6b50349498ef210a0f2f6ee84f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/SOLO.jpg
// module id = 1294
// module chunks = 0